import { Permission } from '@infrastructure/authorization/constants';
import type { Nullable } from 'global-types';

export type RouteType = {
  path: string;
  element: React.ReactNode;
  title: React.ReactNode | string;
  description: React.ReactNode | Nullable<string>;
  permissions: Permission[] | undefined;
};

export type RoutesType = Array<RouteType>;

export enum Path {
  HOME = '/',
  CASES = '/cases',
  CASE_DETAILS = '/cases/:id',
  CREATE_CASE = '/create-case',
  CREATE_CASE_BY_SUBMISSION = '/create-case/:id',
}
